import { FC, PropsWithChildren, useState, useMemo } from "react";
import { AlertContext, AlertContextData, AlertData } from "./context";
import { AlertContainer } from "./AlertContainer";

/**
 * The root component for all alerts. Alerts triggered by children are displayed by the alert provider.
 * @deprecated Please use the component in `capitalrx-components-2.0/lib/general`.
 */
export const AlertProvider: FC<PropsWithChildren<{}>> = ({ children }: PropsWithChildren<{}>): JSX.Element => {
  const [currentAlert, setCurrentAlert] = useState<AlertData | null>(null);

  const alertContextValue = useMemo<AlertContextData>(() => {
    return {
      showAlert: (alert: AlertData) => setCurrentAlert(alert),
      hideAlert: () => setCurrentAlert(null),
    };
  }, []);

  return (
    <AlertContext.Provider value={alertContextValue}>
      <AlertContainer currentAlert={currentAlert} />
      {children}
    </AlertContext.Provider>
  );
};
